import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=42de942e&scoped=true&lang=pug"
import script from "./portfolio.vue?vue&type=script&lang=ts"
export * from "./portfolio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42de942e",
  null
  
)

export default component.exports